import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

const Support = () => {
  const inputClass = 'focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
  return (
    <section className='component-support px-8 py-5 md:py-10 relative w-full max-w-screen-md mx-auto'>
      <div className='prose prose-xl dark:prose-invert mb-8'>
        <h2>Not on one of our support and maintenance packages, but need support?</h2>
        <p>When you need a hand with your site but aren't on one of our support and maintenance packages you can raise a support request. We'll aim to respond within 3 business days. </p>
        <em>This work may be chargeable, and we'll always agree any costs in advance.</em>
      </div>
      <form
        name='contact'
        method='POST'
        action='/success'
        data-netlify='true'
        data-netlify-honeypot='bot-field'
        netlify-honeypot='bot-field'
        data-netlify-recaptcha='true'
        className='dark:lg:border-gray-700 space-y-4'>
        <input type='hidden' name='subject' data-remove-prefix value='Website support ticket' />
        <input type='hidden' name='bot-field' />
        <input type='hidden' name='form-name' value='contact' />
        <div className='grid grid-cols-2 gap-6'>
          <div>
            <label className='block mb-2 text-left font-semibold' htmlFor='name'>
              Name
            </label>
            <input className={inputClass} type='text' name='name' id='name' required />
          </div>
          <div>
            <label className='block mb-2 text-left font-semibold' htmlFor='email'>
              Email
            </label>
            <input className={inputClass} type='email' name='email' id='email' required />
          </div>
        </div>

        <div>
          <label className='block mb-2 text-left font-semibold' htmlFor='message'>
            Description
          </label>
          <textarea rows='4' className={inputClass} name='message' id='message' placeholder='Please provide as much information as possible to assist us with your request' required></textarea>
        </div>
        <div>
          <ReCAPTCHA sitekey={process.env.GATSBY_SITE_RECAPTCHA_KEY} />
        </div>
        <div>
          <button type='submit' className='button rounded w-full sm:w-auto'>
            Submit your ticket
          </button>
        </div>
      </form>
    </section>
  )
}

export default Support
